import { render, staticRenderFns } from "./RelayCreate.vue?vue&type=template&id=c2cc5758&"
import script from "./RelayCreate.vue?vue&type=script&lang=ts&"
export * from "./RelayCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports